import React, { Component } from "react";
import { connect } from "react-redux";
import { actionOrderDetails } from "../../../actions/index";
import { bindActionCreators } from "redux";
import InfoIcon from "../../../images/info.png";
class ItemsOrderQty extends Component {
  constructor(props) {
    super(props);
    const qty = parseFloat(this.props.itemdetail.qty_invoiced);
    this.state = {
      totalPrice: this.props.itemdetail.price * qty,
      qty,
    };
  }

  componentWillReceiveProps(nextProps) {
    const currentItem = nextProps.itemdetail;
    const qty_refused =
      currentItem.qty_refused == undefined ? 0 : currentItem.qty_refused;
    const qty = parseFloat(currentItem.qty_invoiced) - qty_refused;
    this.setState({
      totalPrice: currentItem.price * qty,
      qty,
    });
  }
  increaseDecreaseQty(data) {
    // Still increase and decrease options code not verified :- Guna
    console.log("this.props.orderData", this.props.orderData);
    let item = this.props.itemdetail;

    const eachDiscount = (parseFloat(item.discount_amount) + parseFloat(item.loyalty_discount || 0)) / parseFloat(item.qty_ordered);

    let qty = data === "add" ? this.state.qty + 1 : this.state.qty - 1;
    if (item.is_qty_decimal == "1") {
      qty =
        data === "add"
          ? (
            parseFloat(this.state.qty) +
            parseFloat(this.props.itemdetail.qty_invoiced)
          ).toFixed(3)
          : (
            parseFloat(this.state.qty) -
            parseFloat(this.props.itemdetail.qty_invoiced)
          ).toFixed(3);
    }
    // this.props.itemdetail.qty_invoice
    console.log(
      "addLogic",
      qty <= this.props.itemdetail.qty_invoiced,
      qty >= 0,
      qty,
      this.props.itemdetail.qty_invoiced
    );
    const qty_refused = item.qty_refused == undefined ? 0 : item.qty_refused;

    const decreasableAmnt =
      item.is_qty_decimal == "1"
        ? (
          (parseFloat(item.price) - eachDiscount) *
          parseFloat(item.qty_invoiced)
        ).toFixed(3)
        : parseFloat(item.price) - eachDiscount;
    if (qty <= this.props.itemdetail.qty_invoiced && qty >= 0) {
      let totalData = Object.assign({}, this.props.orderData);
      // let order = totalData;

      if (data === "add") {
        // item.qty_refused = item.qty_refused == undefined ? 0 : item.qty_refused;
        const decreasableQty =
          item.is_qty_decimal == "1" ? this.props.itemdetail.qty_invoiced : 1;
        item.qty_refused = qty_refused - parseFloat(decreasableQty);
        // item.qty_invoiced += 1;

        totalData.refund_amount = (
          parseFloat(totalData.refund_amount) - parseFloat(decreasableAmnt)
        ).toFixed(3);
        console.log("refund_amount", totalData.refund_amount);
        // totalData.subtotal = (
        //   parseFloat(totalData.subtotal) + parseFloat(item.price)
        // ).toFixed(3);

        // totalData.grand_total =
        //   parseFloat(totalData.subtotal) +
        //   parseFloat(totalData.shipping_amount) -
        //   parseFloat(totalData.discount_amount) -
        //   parseFloat(totalData.promo_cash);
        // totalData.grand_total = totalData.grand_total.toFixed(3);
        // if (totalData.amount_to_be_collected) {
        //   totalData.amount_to_be_collected = totalData.grand_total;
        // if (item.item_sodexo) {
        //   order.collectable_sodexo =
        //     parseFloat(order.collectable_sodexo) +
        //     parseFloat(item.discounted_price) -
        //     parseFloat(totalData.orderData.wallet_amount) -
        //     parseFloat(totalData.orderData.promo_cash);
        //   order.collectable_sodexo = order.collectable_sodexo.toFixed(2);
        // }
        // }
        //below code is little confusing:-guna
        // if (order.return_reason) {
        //   let items = order.items;
        //   let qty_refused = false;
        //   for (let obj in items) {
        //     if (items[obj].qty_refused) {
        //       qty_refused = true;
        //       break;
        //     }
        //   }
        //   if (!qty_refused) {
        //     delete order.return_reason;
        //   }
        // }
        //add is completed
      } else {
        item.qty_refused = item.qty_refused == undefined ? 0 : item.qty_refused;
        const decreasableQty =
          item.is_qty_decimal == "1" ? this.props.itemdetail.qty_invoiced : 1;
        item.qty_refused = item.qty_refused + parseFloat(decreasableQty);
        // item.qty_invoiced -= 1;
        totalData.refund_amount = totalData.refund_amount
          ? totalData.refund_amount
          : 0;
        // const decreasableAmnt =
        //   item.is_qty_decimal == "1"
        //     ? (parseFloat(item.price) * parseFloat(item.qty_invoiced)).toFixed(
        //         3
        //       )
        //     : item.price;
        totalData.refund_amount = (
          parseFloat(totalData.refund_amount) + parseFloat(decreasableAmnt)
        ).toFixed(3);
        // totalData.subtotal = (
        //   parseFloat(totalData.subtotal) - parseFloat(item.price)
        // ).toFixed(3);
        // totalData.grand_total =
        //   parseFloat(totalData.subtotal) +
        //   parseFloat(totalData.shipping_amount) -
        //   parseFloat(totalData.discount_amount) -
        //   parseFloat(totalData.promo_cash);
        // totalData.grand_total = totalData.grand_total.toFixed(3);
        // if (totalData.grand_total < 0 || !parseInt(totalData.subtotal)) {
        //   totalData.grand_total = 0;
        // }

        // if (totalData.amount_to_be_collected) {
        //   totalData.amount_to_be_collected = totalData.grand_total;
        // if (item.item_sodexo) {
        //   order.collectable_sodexo =
        //     parseFloat(order.collectable_sodexo) -
        //     parseFloat(item.discounted_price) -
        //     parseFloat(totalData.orderData.wallet_amount) -
        //     parseFloat(totalData.orderData.promo_cash);
        //   //  order.collectable_sodexo=order.collectable_sodexo < 0 ? 0 : order.collectable_sodexo;
        //   order.collectable_sodexo = order.collectable_sodexo.toFixed(2);
        //   order.collectable_sodexo =
        //     order.collectable_sodexo > 0 ? order.collectable_sodexo : 0;
        // }
        // }
      }
      console.log("qty", totalData);

      this.props.actionOrderDetails(totalData);
      // localStorage.setItem("orderData", JSON.stringify(totalData));
      // this.setState({
      //   qty,
      //   totalPrice: qty * this.props.itemdetail.price
      // });
    }
  }
  render() {
    const itemdata = this.props.itemdetail;
    console.log("verify0", itemdata);
    console.log(
      "verify",
      itemdata.qty_refused,
      parseInt(itemdata.qty_refunded)
    );
    const eachDiscountAmount =
      parseFloat(itemdata.discount_amount) / parseFloat(itemdata.qty_ordered);
    return (
      <div className="deliverItemContainer">
        <span className="deliverItemName">{itemdata.name}</span>
        <div className="deliverItem">
          <span className="deliverItemPrice">
            {parseFloat(Number(itemdata.price) - eachDiscountAmount).toFixed(3)}
          </span>
          <span className="deliverItemQty">
            <div className="item_qty_inner">
              <div className="deliverItem_qty_block">
                <div className="deliverItemBtnContainer">
                  <button
                    className="deliverItemminus"
                    onClick={(e) => this.increaseDecreaseQty("sub")}
                  >
                    -
                  </button>

                  <span className="deliverItemBoxQty">
                    {parseFloat(this.state.qty).toFixed(3)}
                  </span>

                  <button
                    className="deliverItemplus"
                    onClick={(e) => this.increaseDecreaseQty("add")}
                  >
                    +
                  </button>
                </div>
                <div className="deliverItemReturned">
                  {itemdata.qty_refused || parseFloat(itemdata.qty_refunded) ? (
                    <span>
                      <img
                        src={InfoIcon}
                        alt="Arrow"
                        className="deliverItemInfoIcon"
                      />
                      {(
                        parseFloat(itemdata.qty_refused) +
                        parseFloat(itemdata.qty_refunded)
                      ).toFixed(3)}
                      {/* {" "}
                      of {parseInt(itemdata.qty_invoiced)} */}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </span>
          <span className="deliverItem_total_price">
            {(
              (parseFloat(itemdata.price) - eachDiscountAmount) *
              itemdata.qty_invoiced
            ).toFixed(3)}
            <div>
              {itemdata.qty_refused || parseInt(itemdata.qty_refunded) ? (
                <span>
                  <img
                    src={InfoIcon}
                    alt="Arrow"
                    className="deliverItemInfoIcon"
                  />
                  {(
                    (parseFloat(itemdata.price) - eachDiscountAmount) *
                    (itemdata.qty_refused + parseInt(itemdata.qty_refunded))
                  ).toFixed(3)}
                </span>
              ) : (
                ""
              )}
            </div>
          </span>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    orderData: state.orderDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { actionOrderDetails: actionOrderDetails },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(ItemsOrderQty);



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/ItemsOrderQty.js